
export const attributeNames = [
'company',
'description',
'purchaseDisabled',
'note',
'valveType',
'productType',
'Shop_AM_CA',
'Shop_AM_US',
'Shop_EU_AE',
'Shop_EU_AT',
'Shop_EU_BE',
'Shop_EU_CH',
'Shop_EU_CH_EUR',
'Shop_EU_DE',
'Shop_EU_ES',
'Shop_EU_FI',
'Shop_EU_FR',
'Shop_EU_IE',
'Shop_EU_IT',
'Shop_EU_NL',
'Shop_EU_NO',
'Shop_EU_PL',
'Shop_EU_SE',
'Shop_EU_TR',
'Shop_EU_UK',
'Shop_AP_AU',
'Shop_AP_AU_NZD',
'Shop_AP_CN',
'Shop_AP_HK',
'Shop_AP_HK_USD',
'Shop_AP_HK_SAR',
'Shop_AP_IN',
'Shop_AP_MY',
'Shop_AP_MY_USD',
'Shop_AP_MY_SGD',
'image',
'specification',
'installationInstructions',
'accessoryType',
'zOption',
'dn',
'family',
'vnomm3h',
'vnomls',
'vnomlh',
'kvs',
'kvmax',
'kvssequence1',
'kvssequence2',
'kvstheor',
'maxDiffPressure',
'PN',
'FluidTemperatureRange',
'ValveBody',
'LeakageRate',
'FlowCharacteristic',
'ValveSymbol',
'PermissiblePressure',
'Vmaxpos1',
'Vmaxpos2',
'Vmaxpos3',
'Vmaxpos4',
'Vmaxpos5',
'Vmaxpos6',
'Vmaxpos7',
'Vmaxpos8',
'Vmaxpos9',
'Vmaxpos10',
'Vmaxpos11',
'Vmaxpos12',
'Vmaxpos13',
'Vmaxpos14',
'Vmaxpos15',
'kvspos1',
'kvspos2',
'kvspos3',
'kvspos4',
'kvspos5',
'kvspos6',
'kvspos7',
'bodySize',
'cv',
'vnomgpm',
'cvsequence1',
'cvsequence2',
'closeOffPressure',
'bodyPressureRating',
'trim',
'protection',
'torqueInLb',
'actuatingForceLbf',
'preferred',
'note1',
'note2',
'note3',
'note4',
'nominalVoltage',
'torque',
'actuatingForce',
'failSafeFunction',
'runningTime',
'controlType',
'integratedSwitch',
'stroke',
'controlTypeDescription',
'electricalConnection',
'ProductSubHeader',
'DisplayType',
'SensorApplication',
'OutputSignal',
'MeasuredValues',
'MeasuringRangeCO2',
'ProbeLength',
'CableLength',
'm_MeasuringRangeTemperature',
'i_MeasuringRangeTemperature',
'MeasuringRangeRH',
'AdditionalFeatures',
'm_flow',
'i_flow',
'm_dn',
'i_dn',
'pressureAir',
'certification',
'mountingType',
'Type',
'Pattern',
'Fluid',
'OperationMode',
'ValveType',
'raw_Type',
'raw_Pattern',
'raw_Fluid',
'raw_OperationMode',
'raw_ValveType',
'_511_Kvs_Sequence_2',
'_28_Differential_pressure_deltapmaxValue',
'_6686_Leakage_rate',
'_6969_Seq_2_Cv',
'_1003_Flow_characteristic',
'_461_Fluid_Temp_Range_water',
'CloseOffPressure',
'_37_Permissible_operating_pressure_ps',
'_25_Leakage_rate',
'Medium',
'OutputSignalPassiveTemperature',
'MeasuringRangePressure',
'MeasuringRangePressureBar',
'MeasuringRangePressurePSI'
] as const;
export type AttributeAlias = typeof attributeNames[number];
export const AttributesAliases: Record<AttributeAlias, string> = {
company: '7687',
description: '800',
purchaseDisabled: '5684',
note: '7519',
valveType: '7700',
productType: '6691',
Shop_AM_CA: '2759',
Shop_AM_US: '2758',
Shop_EU_AE: '2745',
Shop_EU_AT: '2726',
Shop_EU_BE: '2727',
Shop_EU_CH: '2724',
Shop_EU_CH_EUR: '2725',
Shop_EU_DE: '2728',
Shop_EU_ES: '2729',
Shop_EU_FI: '2732',
Shop_EU_FR: '2733',
Shop_EU_IE: '2734',
Shop_EU_IT: '2735',
Shop_EU_NL: '2737',
Shop_EU_NO: '2738',
Shop_EU_PL: '2739',
Shop_EU_SE: '2742',
Shop_EU_TR: '2743',
Shop_EU_UK: '2736',
Shop_AP_AU: '2749',
Shop_AP_AU_NZD: '2752',
Shop_AP_CN: '2755',
Shop_AP_HK: '2753',
Shop_AP_HK_USD: '2754',
Shop_AP_HK_SAR: '2744',
Shop_AP_IN: '2756',
Shop_AP_MY: '2746',
Shop_AP_MY_USD: '2748',
Shop_AP_MY_SGD: '2747',
image: '377',
specification: '660',
installationInstructions: '6314',
accessoryType: '8159',
zOption: '8543',
dn: '3455',
family: '7266',
vnomm3h: '6943',
vnomls: '3460',
vnomlh: '7153',
kvs: '14',
kvmax: '78',
kvssequence1: '510',
kvssequence2: '511',
kvstheor: '6827',
maxDiffPressure: '35',
PN: '528',
FluidTemperatureRange: '461',
ValveBody: '32',
LeakageRate: '25',
FlowCharacteristic: '1003',
ValveSymbol: '2798',
PermissiblePressure: '23',
Vmaxpos1: '548',
Vmaxpos2: '6323',
Vmaxpos3: '6327',
Vmaxpos4: '8669',
Vmaxpos5: '8670',
Vmaxpos6: '8671',
Vmaxpos7: '8672',
Vmaxpos8: '8673',
Vmaxpos9: '8674',
Vmaxpos10: '8675',
Vmaxpos11: '8676',
Vmaxpos12: '8677',
Vmaxpos13: '8678',
Vmaxpos14: '8679',
Vmaxpos15: '8680',
kvspos1: '8681',
kvspos2: '8682',
kvspos3: '8683',
kvspos4: '8684',
kvspos5: '8685',
kvspos6: '8686',
kvspos7: '8687',
bodySize: '880',
cv: '148',
vnomgpm: '347',
cvsequence1: '6968',
cvsequence2: '6969',
closeOffPressure: '8318',
bodyPressureRating: '417',
trim: '32',
protection: '145',
torqueInLb: '65',
actuatingForceLbf: '223',
preferred: '2797',
note1: '7881',
note2: '7882',
note3: '7883',
note4: '7884',
nominalVoltage: '83',
torque: '65',
actuatingForce: '223',
failSafeFunction: '8160',
runningTime: '230',
controlType: '281',
integratedSwitch: '112',
stroke: '16',
controlTypeDescription: '121',
electricalConnection: '6759',
ProductSubHeader: '886',
DisplayType: '7977',
SensorApplication: '7844',
OutputSignal: '7373',
MeasuredValues: '7786',
MeasuringRangeCO2: '7801',
ProbeLength: '7984',
CableLength: '93',
m_MeasuringRangeTemperature: '7906',
i_MeasuringRangeTemperature: '8255',
MeasuringRangeRH: '7797',
AdditionalFeatures: '8013',
m_flow: '8107',
i_flow: '8581',
m_dn: '15',
i_dn: '3455',
pressureAir: '8387',
certification: '504',
mountingType: '8534',
Type: '8162',
Pattern: '6560',
Fluid: '6673',
OperationMode: '8165',
ValveType: '7266',
raw_Type: '8162',
raw_Pattern: '6560',
raw_Fluid: '6673',
raw_OperationMode: '8165',
raw_ValveType: '7266',
_511_Kvs_Sequence_2: '511',
_28_Differential_pressure_deltapmaxValue: '28',
_6686_Leakage_rate: '6686',
_6969_Seq_2_Cv: '6969',
_1003_Flow_characteristic: '1003',
_461_Fluid_Temp_Range_water: '461',
CloseOffPressure: '8318',
_37_Permissible_operating_pressure_ps: '37',
_25_Leakage_rate: '25',
Medium: '6673',
OutputSignalPassiveTemperature: '8060',
MeasuringRangePressure: '8387',
MeasuringRangePressureBar: '8028',
MeasuringRangePressurePSI: '8256'
}
